import { jsonp, ajax, restAjax, cookie } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
const apiBaseUrl = commentApi;
/* eslint-enable no-undef */
// eslint-disable-next-line no-undef
const choujiangBaseUrl = choujangUrl;

// eslint-disable-next-line no-undef
const weixinLoginBaseUrl = weixinLogin;

/**
 *
 * @returns 获取评论列表
 */
const getComment = async (ucmsId) => {
    return await jsonp(`${apiBaseUrl}/get/comments?doc_url=ucms_${ucmsId}&p=1&pagesize=30&orderby=integral&format=js`);
};

export const submitApi = async ({ content, docUrl, docName, link, skey }) => {
    const data = await jsonp(`${apiBaseUrl}/post.php?docUrl=ucms_${docUrl}&docName=${encodeURIComponent(docName)}&skey=${skey}&format=js&content=${content}&permalink=${encodeURIComponent(link)}`, {
        jsonpCallback: 'postCmt',
        cache: false,
    });

    return data;
};

const getKey = async () => {
    return ajax('https://api.cmpp.v.ifeng.com/index.php/api/WeiboSecret', {
        type: 'post',
        data: { url: encodeURIComponent(window.location.href) },
    });
};

const add = async () => {
    // todo 二期投票时候需要打开
    return restAjax(`${choujiangBaseUrl}/Active_Lottery_Vote/add`, { corsCookie: true });
};

const afterVote = async () => {
    return restAjax(`${choujiangBaseUrl}/Active_Lottery_Vote/vote`, { corsCookie: true });
};

const getNum = async () => {
    const sid = cookie.get('sid') || '';

    return restAjax(`${choujiangBaseUrl}/Active_Lottery_Vote/get?sid=${sid}`, { corsCookie: true });
};

const getList = async () => {
    return restAjax(`${choujiangBaseUrl}/Active_Lottery_Prize/getList`, { corsCookie: true });
};

const getDrawAction = async (version) => {
    const formData = new FormData();

    formData.append('version', version);

    return fetch(`${choujiangBaseUrl}/Active_Lottery_Lottery/draw`, { method: 'post', body: formData, credentials: 'include' });
};

const saveAddress = async (params) => {
    return fetch(`${choujiangBaseUrl}/Active_Lottery_Lottery/saveAddress`, { method: 'post', body: params, credentials: 'include' });
};

const toweixinLogin = async (code) => {
    return restAjax(`${weixinLoginBaseUrl}/Api_User_Userbasic/weixinLogin?code=${code}&proid=weixinh5`);
};

const getPhoneCode = async (query) => {
    return restAjax('https://api-tousu.ifeng.com/open-user-login/ifeng/sendShortMessage', { query });
};

const getImageCode = async () => {
    return restAjax('https://api-tousu.ifeng.com/open-user-login/ifeng/getCaptcha?type=0');
};

const phoneNumberLogin = async (query) => {
    return restAjax('https://api-tousu.ifeng.com/open-user-login/ifeng/loginByShortMessageCode', { query });
};

const getUserInfo = async (token) => {
    return fetch('https://api-tousu.ifeng.com/open-user-manager/outside/getUserBaseInformation', { headers: { Authorization: `Bearer ${token}` } });
};

/**
 *
 * @returns 投票
 */
const vote = async (params) => {
    return await jsonp(`https://sv.ifeng.com/index.php/survey/postsurvey?${params}`);
};

export { getComment, getKey, add, getNum, vote, afterVote, getList, getDrawAction, saveAddress, toweixinLogin, getPhoneCode, getImageCode, phoneNumberLogin, getUserInfo };
